<template>
  <section>
    <RequisiteAdvanceRules
      :value="value.rules"
      :level="level"
    />
    <div
      v-if="value.freeFormText"
      class="pt-4 mt-4 border-t reset-liststyle text-base md:text-lg requisite-content"
      v-html="value.freeFormText"
    />
  </section>
</template>

<script>
import RequisiteAdvanceRules from './RequisiteAdvanceRules'

export default {
  components: {
    RequisiteAdvanceRules,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    level: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style>
.requisite-content > .link {
  text-decoration: underline;
  color: var(--theme-light, #006cb8) !important;
}
</style>
